const header = document.querySelector('.header-default')
const navbarPrimary = document.querySelector('#navbar--primary')
const collapsePrimary = document.querySelector('#collapse--primary')
const navbarToggler = document.querySelector('#navbar-toggler')

let lastScroll = 0
const threshold = 35

window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset
  const scrollDelta = currentScroll - lastScroll

  if (currentScroll > threshold + 20) {
    header.classList.add('background')
  } else {
    header.classList.remove('background')
  }

  if (currentScroll <= threshold) {
    header.style.transform = 'translateY(0)'
    return
  }

  if (Math.abs(scrollDelta) < threshold) return

  if (scrollDelta > 0) {
    header.style.transform = 'translateY(-101%)'
    header.classList.add('fixed')
    navbarPrimary.classList.remove('open')
    collapsePrimary.classList.remove('show')
    navbarToggler.setAttribute('aria-expanded', 'false')
  } else {
    header.style.transform = 'translateY(0)'
    header.classList.remove('fixed')
  }

  lastScroll = currentScroll
})



